import styled from 'styled-components'
import { theme } from '../../../style/theme'

export const TaxInfoMessageWrap = styled.div`
	font-size: 1em;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	min-height: 2.75em;
	padding: 0.12em 1.43em;
	gap: 0.19em;
	background: #FFF9C4;
	width: 100%;
`
TaxInfoMessageWrap.displayName = 'TaxInfoMessageWrap'

export const TaxInfoMessageContent = styled.div`
    display: flex;
    gap: 0.31em;

		> svg {
			width: 0.94em;
			height: 0.94em;
			fill: #2981EE;
			flex-shrink: 0;
		}
`
TaxInfoMessageContent.displayName = 'TaxInfoMessageContent'

export const TaxInfoMessageText = styled.div`
	color: #000;
	font-family: ${theme.fontRoboto};
	font-size: 1.125em;
	font-weight: 400;
	text-align: center;

	&.bold {
		font-family: ${theme.fontRobotoBold};
		font-weight: 600;
	}

	strong {
		font-family: ${theme.fontRobotoBold};
		font-weight: 700;
	}
`
TaxInfoMessageText.displayName = 'TaxInfoMessageText'
